import { useState } from 'react'
import { toast } from 'react-hot-toast'
import Web3 from 'web3'
import Button from '../components/Button'
import Input from '../components/Input'
import { isValidTxHash, recursionCalls } from '../utils'
import { ApiKey, SupportedChains } from '../utils/constants'

function Debug() {
    const [data, setData] = useState('')
    const [key, setKey] = useState('')
    const [output, setOutput] = useState('')
    const [error, setError] = useState('')
    const callFunction = async () => {
        let web3: Web3 | undefined = undefined
        if (!web3) {
            try {
                await (window as any).ethereum.enable()
                web3 = new Web3((window as any).ethereum)
            } catch (error: any) {
                toast.error(`You need to connect Wallet. Error: ${error.toString()}`)
                return
            }
        }
        if (!data || !key) {
            toast.error('Please enter txhash and api key')
            return
        }
        if (key !== ApiKey) {
            toast.error('Invalid API key')
            return
        }
        if (!isValidTxHash(data)) {
            toast.error('Invalid txHash')
            return
        }
        const chainId = await web3.eth.getChainId()
        if (!chainId) {
            toast.error('Can not detect chain id')
            return
        }
        if (!SupportedChains[chainId.toString()]) {
            toast.error(`Chain id ${chainId} was not supported`)
            return
        }
        const settings = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'debug_traceTransaction',
                params: [data],
                id: new Date().getTime(),
            }),
        }

        const response = await fetch(SupportedChains[chainId.toString()], settings)
        const resonseData = await response.json()
        setOutput(JSON.stringify(resonseData))
        const calls = resonseData.result.calls
        const resultError = recursionCalls(null, calls)
        setError(JSON.stringify(resultError, null, 2))
    }

    return (
        <>
            <div className="container">
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setData(e.target.value)
                        }}
                        value={data}
                        placeholder="Txhash to debug"
                        type="text"
                        name="data"
                    />
                </div>

                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setKey(e.target.value)
                        }}
                        value={key}
                        placeholder="Api key"
                        type="text"
                        name="topic"
                    />
                </div>
                <div className="section-choose__buttons">
                    <Button className="add-param" onClick={callFunction}>
                        Call
                    </Button>
                </div>
                <div className="section encoded-section">
                    <textarea
                        className="method-input__value"
                        placeholder="Result"
                        rows={20}
                        cols={80}
                        autoComplete="off"
                        value={output}
                    />
                </div>
                {error && (
                    <div className="section encoded-section ">
                        <pre className="pretty-json">{error}</pre>
                    </div>
                )}
            </div>
        </>
    )
}

export default Debug
